var shareholdersTable = $('#largest-shareholders');
var initialAmount = 10;
var totalAmount = 20;
//shareholdersTable.find('tbody tr:nth-last-child(-n+'+(totalAmount-initialAmount)+')').hide();


jQuery( document ).ready( function() {
    if( isOnScreen( jQuery( '#largest-shareholders' ) ) ) {
        runShareholders('first-part');
    } else {
        window.addEventListener('scroll', function(e) {
            if( isOnScreen( jQuery( '#largest-shareholders' ) ) ) { /* Pass element id/class you want to check */
                runShareholders('first-part');
            }
         });
    };
});

//optional param animateThese: "last-part" || "first-part"
function runShareholders(animateThese){
    var shareholders;

    if(animateThese === 'first-part' && shareholdersTable.find('tbody tr:last-child').is(':hidden'))
        shareholders = shareholdersTable.find('tbody tr').slice(0,initialAmount);
    else if(animateThese === 'last-part'){
        shareholders = shareholdersTable.find('tbody tr:nth-last-child(-n+'+(totalAmount-initialAmount)+')');
        shareholders.fadeIn();
    }else{
        shareholders = shareholdersTable.find('tr');
    }

    var maxPercentage = shareholdersTable.find('tbody td.bar').first().data('percentage'); // get the one with highest percentage

    shareholders.each(function(i,val){
        var bar = $(val).find('.bar');
        var percentage = bar.data('percentage');
        var x = 0.00;

        var becomeWidthSize = 100*(percentage/maxPercentage);

        var span = bar.find('span');
        setTimeout(function(){
            span.animate({
                'width' : becomeWidthSize+'%'
            }, {
                duration: 2000,
                //easing: 'easeOutCubic'
            });
        },i*75+300);

    });

}

function isOnScreen(elem) {
    // if the element doesn't exist, abort
    if( elem.length == 0 ) {
        return;
    }
    var $window = jQuery(window)
    var viewport_top = $window.scrollTop()
    var viewport_height = $window.height()
    var viewport_bottom = viewport_top + viewport_height
    var $elem = jQuery(elem)
    var top = $elem.offset().top
    var height = $elem.height()
    var bottom = top + height

    return (top >= viewport_top && top < viewport_bottom) ||
        (bottom > viewport_top && bottom <= viewport_bottom) ||
        (height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)
}